import React, { useMemo } from "react";
import PropTypes from "prop-types";
import FluentUiIcon from "../../assets/fluent-ui-icon";
import { AvatarGroupItem } from "@fluentui/react-components";
import "./member-icon-new.scss";

const MemberIconMultipleOwner = ({ member, extraMembers, fromTask = false }) => {
  const memberData = member || {};
  const userData = memberData.User || {};
  const groupData = memberData.Group || {};
  const IsGroup = memberData.IsGroup || false;
  const IsOwner = memberData.IsOwner || false;
  const displayName = userData.Name || memberData.Name || groupData.Name || "";
  // Archived/moved assignee (TAD-5898): grey the avatar. The flag is only ever
  // set on task-assignee payloads, so other consumers of this shared component
  // are unaffected.
  const isArchived =
    userData.Archived === true || userData.Deleted === true || memberData.Archived === true;

  const initials = useMemo(() => {
    if (extraMembers >= 99) return "99+";
    if (extraMembers > 0) return `+${extraMembers}`;
  }, [extraMembers, displayName]);

  // Archived/moved assignees keep their identity color; the
  // .list-avatar-archived opacity softens the avatar (TAD-5898).
  const avatarColor = useMemo(() => {
    if (extraMembers > 0) return fromTask ? "transparent" : "platinum";
    if (IsGroup) return IsOwner ? "dark-red" : "red";
    return IsOwner ? "brand" : "blue";
  }, [extraMembers, fromTask, IsGroup, IsOwner]);

  const badge = useMemo(() => {
    if (extraMembers > 0) return undefined;
    if (!IsGroup) return undefined;
    return {
      icon: (
        <FluentUiIcon
          name="PeopleFilled"
          color={IsOwner ? "#370B10" : "#CD9EA5"}
          size={8}
        />
      )
    };
  }, [extraMembers, IsGroup, IsOwner]);

  return (
    extraMembers > 0 ? (
      <AvatarGroupItem
        className="list-avatar-extra-grey-border"
        size={28}
        initials={initials}
        color={avatarColor}
        badge={badge}
      />
    ) :
      <AvatarGroupItem
        className={`list-avatar-multi-owner${isArchived ? " list-avatar-archived" : ""}`}
        size={28}
        name={displayName}
        color={avatarColor}
        badge={badge}
      />
  );
};

MemberIconMultipleOwner.propTypes = {
  member: PropTypes.shape({
    Name: PropTypes.string,
    IsGroup: PropTypes.bool,
    IsOwner: PropTypes.bool,
    User: PropTypes.shape({
      Name: PropTypes.string,
      Initials: PropTypes.string
    }),
    Group: PropTypes.shape({
      Name: PropTypes.string
    })
  }),
  extraMembers: PropTypes.number,
  fromTask: PropTypes.bool
};

MemberIconMultipleOwner.defaultProps = {
  member: null,
  fromTask: false
};

export default MemberIconMultipleOwner;